import type React from 'react';

export const SendField: React.FC<{
	fieldName: string;
	fieldValue: string | undefined | null;
}> = ({ fieldName, fieldValue }) => {
	if (!fieldValue) {
		return null;
	}
	return (
		<p className="admin:my-1 admin:break-all">
			<strong>{`${fieldName}: `}</strong>
			{fieldValue}
		</p>
	);
};
